import Rest from '../Rest'

export default class FinancialInstitutionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/financial_institutions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
